import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';

@Injectable()
export class BillingRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient
  ) {
  }

  planList() {
    const url = `${this.config.baseUrl}/v2/${this.config.services.billing}/plans`;
    return this.http.get(url);
  }
}
